import { useState } from "react";
import { FaRegStar } from "react-icons/fa";
import { FiSmile } from "react-icons/fi";
import { PiArrowBendUpLeftBold } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import { FiMinimize } from "react-icons/fi";
import { BiCollapseVertical, BiExpandVertical } from "react-icons/bi";
import { TbBaselineDensitySmall } from "react-icons/tb";
import EmailIframe from "../chat/EmailIframe";
import EmailContent from "./EmailContent";
import { convertToIST } from "../../utils/dateTimeUtils";



export default function EmailConversation({ outlookEmailThread, setLoading, loading }) {
  const [expanded, setExpanded] = useState(false);
  const [openEmail, setOpenEmail] = useState(null);

  const [isAnalyticsView, setIsAnalyticsView] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const visibleCount = 3;

  const toggleView = () => {
    setIsAnalyticsView(!isAnalyticsView);
  };



  function extractLatestEmailContent(emailBody) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(emailBody, "text/html");

    // Find the first <div dir="ltr"> which usually contains the latest email
    const latestEmailDiv = doc.querySelector("div[dir='ltr']");

    if (latestEmailDiv) {
      return latestEmailDiv.outerHTML; // Extract only this part
    }

    return emailBody; // Fallback to full body if no match found
  }


  const emails = [
    { id: 1, sender: "Alice", subject: "Meeting Reminder", body: "Don't forget our meeting at 3 PM." },
    { id: 2, sender: "Bob", subject: "Project Update", body: "The latest project updates are attached." },
    { id: 3, sender: "Charlie", subject: "Invoice Details", body: "Invoice #1234 has been processed." },
    { id: 4, sender: "David", subject: "Team Outing", body: "Let's plan our team outing next week!" },
    { id: 5, sender: "Emma", subject: "Product Launch", body: "The new product will be launched soon." },
    { id: 6, sender: "Frank", subject: "Weekly Report", body: "Here is the weekly report summary." },
    { id: 7, sender: "Grace", subject: "Holiday Schedule", body: "Updated holiday schedule attached." },
    { id: 8, sender: "Hannah", subject: "New Policy Update", body: "Important policy updates enclosed." },
    { id: 9, sender: "Ian", subject: "Feedback Request", body: "Please provide your feedback on our service." }
  ];

  const visibleEmails = expanded
    ? outlookEmailThread
    : outlookEmailThread.length > 4
      ? [outlookEmailThread[0], "expand", ...outlookEmailThread.slice(-2)]
      : outlookEmailThread;

  return (
    <div className="w-full mx-auto p-4 pl-0 pr-0 ">
      <div className="flex text-gray-800 items-center text-md font-semibold gap-2 pl-0 p-4">
        <TbBaselineDensitySmall size={20} /> Conversation Thread
      </div>
      <div className="divide-y divide-gray-300 border rounded-md border-gray-300 ">

        {visibleEmails.map((email, index) => (
          email === "expand" ? (
            <button
              key={index}
              onClick={() => setExpanded(true)}
              className="w-full relative p-2 text-center text-blue-600 hover:underline flex items-center justify-center transition-all"
            >
              {/* Show {outlookEmailThread.length - 3} more <HiChevronDown size={16} /> */}
              <div className="absolute p-2 rounded-full border bg-gray-100 border-gray-400 text-gray-400 hover:border-gray-600 hover:text-gray-600 hover:bg-gray-200">
                <BiExpandVertical size={20} />
              </div>
            </button>
          ) : (
            <div
              key={email.id}
              className="p-3  cursor-pointer transition-all duration-300 ease-in-out"
              onClick={() => setOpenEmail(openEmail === email.id ? null : email.id)}
            >
              {!(openEmail === email.id) ? (
                <div
                  className="flex items-center  justify-between transition-all duration-300 ease-in-out "
                >
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-gray-700  text-white flex items-center justify-center rounded-full text-sm font-bold">
                      {email.sender?.name[0].toUpperCase()}
                    </div>
                    <div className="ml-3 text-gray-800">{email?.sender?.name}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-500 text-sm">{convertToIST(email?.date).date || ""}</span>
                    <span className="text-gray-500 text-sm">{convertToIST(email?.date).time || ""}</span>
                    <button
                      className="text-gray-500 flex items-center hover:text-gray-700 ml-4 "
                    >
                      <FaRegStar />
                    </button>
                  </div>
                </div>
              )
                : (
                  <>
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="flex flex-row mt-4 w-full transition-all duration-300 ease-in-out">
                      <div className="px-4 pl-0">
                        <div className="w-10 h-10 bg-gray-700 text-white flex items-center justify-center rounded-full text-sm font-bold">
                          {email.sender?.name[0].toUpperCase()}
                        </div>
                      </div>
                      <div className="flex flex-col w-full">
                        <div className="flex items-center justify-between">
                          <div className="flex text-gray-700 items-center mb-4">
                            <div className="flex flex-col">
                              <span className="font-semibold">
                                {/* {email.from?.name} */}
                                <span className="font-normal text-sm text-gray-500">{email.from.contact || "No Sender"}</span>
                              </span>


                              <div className="flex">
                                {!loading && <span className="text-gray-500 mr-2"> to  </span>}
                                <div className="flex items-center">
                                  {email.to?.slice(0, visibleCount).map((to, index) => (
                                    <span
                                      key={index}
                                      className="font-semibold"
                                      title={to?.email || "No Recipient"}
                                    >
                                      {to?.name || to?.email || "No Recipient"}
                                      {index < Math.min(visibleCount, email.to?.length) - 1 && ", "}
                                    </span>
                                  ))}

                                  {/* Toggle button to expand/collapse extra recipients */}
                                  {email.to?.length > visibleCount && (
                                    <button
                                      className="ml-1 text-[#5652CF] hover:underline flex items-center"
                                      onClick={() => setShowAll(!showAll)}
                                    >
                                      {showAll ? "show less" : `+${email.to?.length - visibleCount}`}
                                      {showAll ? <HiChevronUp size={14} /> : <HiChevronDown size={14} />}
                                    </button>
                                  )}
                                </div>

                                {/* Extra emails, smoothly expanding below */}
                                <div
                                  className={`border border-gray-400 p-2 rounded-xl transition-all duration-300 ease-in-out text-gray-500 font-semibold ${showAll ? "max-h-40 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                                    }`}
                                >
                                  {email.to?.slice(visibleCount).map((to, index) => (
                                    <span key={index} className="block text-sm text-gray-700">
                                      {to?.name || to?.email || "No Recipient"}
                                    </span>
                                  ))}
                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="flex flex-col gap-2 text-sm mr-4">
                            <div className='flex gap-3'>
                              <div className="flex gap-2 items-center mb-2">
                                <button
                                  className={`px-3 py-1 text-xs text-white rounded flex items-center justify-center transition ${loading ? "h-4 w-14 bg-gray-300 animate-pulse" : "bg-zinc-500 hover:bg-zinc-600"
                                    }`}
                                  onClick={toggleView}
                                  disabled={loading}
                                >
                                  {loading ? "" : isAnalyticsView ? "View Email" : "AI View"}
                                </button>
                                {!loading ? (
                                  <span className="text-gray-500 text-sm">{convertToIST(email?.date).date || ""}</span>
                                ) : (<div className="w-3/4 h-3 bg-gray-500 animate-pulse rounded"></div>)}
                              </div>
                              <div className="flex items-center mb-2">
                                {!loading ? (
                                  <span className="text-gray-500 text-sm">{convertToIST(email?.date).time || ""}</span>
                                ) : (<div className="w-3/4 h-3 bg-gray-300 animate-pulse rounded"></div>)}
                              </div>
                              <button
                                className="text-gray-500 hover:text-gray-700 mb-2"
                              >
                                <FaRegStar />
                              </button>
                              <button
                                className="text-gray-500 hover:text-gray-700 mb-2"
                              >
                                <FiSmile />
                              </button>
                              <button
                                className="text-gray-500 hover:text-gray-700 mb-2"
                              >
                                <PiArrowBendUpLeftBold />
                              </button>
                              <button
                                onClick={() => setOpenEmail(openEmail === email.id ? null : email.id)}
                                className="text-gray-500 hover:text-gray-700 mb-2"
                              >
                                <BiCollapseVertical size={15} />
                              </button>
                              <button
                                className="text-gray-500 hover:text-gray-700 mb-2"
                              >
                                <BsThreeDotsVertical />
                              </button>
                            </div>
                            <div class="flex justify-end mb-2">
                              <span
                                className={`px-3 py-1 text-xs font-semibold text-white rounded-md 
                                  ${email?.priority === 1 || email?.priority === 0 ? "bg-blue-400" :
                                    email?.priority >= 2 && email?.priority <= 3 ? "bg-yellow-400" :
                                      email?.priority >= 4 ? "bg-red-400" :
                                        "bg-gray-500"
                                  }`}
                              >
                                {email?.priority === 1 || email?.priority === 0 ? "Low" :
                                  email?.priority >= 2 && email?.priority <= 3 ? "Medium" :
                                    email?.priority >= 4 ? "High" :
                                      "Unknown"}
                              </span>
                            </div>

                          </div>
                        </div>
                        <EmailContent
                          email={email}
                          loading={loading}
                          isAnalyticsView={isAnalyticsView}
                          messageId={email?.message_id}
                          isDialog={true}
                          isOutlook={true}
                          setIsFullScreen={setIsFullScreen}
                          isConversationThread={true}

                        />
                      </div>
                    </div>

                    {
                      isFullScreen && (
                        <div className="fixed inset-0 w-screen h-screen bg-white z-50 p-6 transition-all duration-300 ease-in-out">
                          {/* Close button stays fixed at top-right */}
                          <button
                            className="absolute bottom-8 mb-4 right-14 bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700 p-2 rounded-full transition-all transform hover:scale-110"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsFullScreen(false);
                            }}
                          >
                            <FiMinimize size={24} />
                          </button>

                          {/* Scrollable content */}
                          <div
                            onClick={(e) => e.stopPropagation()}
                            className="overflow-auto h-full scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
                            {/* <article
                              dangerouslySetInnerHTML={{ __html: email.body }}
                              className="text-gray-700 min-h-60 flex items-center justify-center whitespace-pre-line"
                            /> */}
                            <EmailIframe emailBody={email.body}></EmailIframe>
                          </div>

                        </div>
                      )
                    }
                  </>

                )}

            </div>
          )


        ))}
      </div>
      {expanded && (
        <button
          onClick={() => setExpanded(false)}
          className="mt-3 flex items-center justify-center w-full text-blue-600 hover:underline transition-all duration-300 ease-in-out"
        >
          <div className="p-2 rounded-full border border-gray-400 text-gray-400 hover:border-gray-600 hover:text-gray-600 hover:bg-gray-200">
            <BiCollapseVertical size={20} />
          </div>
        </button>
      )}


    </div>
  );
}